/**
 * PitchPrint Load Saved Project
 *
 * This script checks for pp_project URL parameter and ensures the project
 * is available in localStorage for PitchPrint to discover.
 */

(function() {
  'use strict';

  // Check for pp_project parameter
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('pp_project');

  if (!projectId) {
    console.log('[LoadProject] No pp_project parameter found');
    return;
  }

  console.log('[LoadProject] Found pp_project parameter:', projectId);

  // Ensure the project exists in localStorage for PitchPrint to find
  try {
    let projects = localStorage.getItem('pprint-projects');
    if (!projects) {
      projects = {};
    } else {
      projects = JSON.parse(projects);
    }

    // Check if this project already exists
    if (!projects[projectId]) {
      console.log('[LoadProject] Project not in localStorage, adding placeholder entry');

      // Get product info from page
      const productId = document.querySelector('[data-product-id]')?.dataset?.productId ||
                        window.product?.id || '';

      // Create a minimal entry so PitchPrint knows to fetch from server
      const projectData = {
        projectId: projectId,
        numPages: 2,
        meta: {},
        userId: window.ppCustomerData?.id || '',
        product: {
          id: productId,
          name: window.location.pathname,
          title: document.title,
          url: window.location.href
        },
        type: 'p',
        isvx: true,
        distiller: 'https://xpdf.pitchprint.com'
      };

      projects[projectId] = encodeURIComponent(JSON.stringify(projectData));
      localStorage.setItem('pprint-projects', JSON.stringify(projects));
      console.log('[LoadProject] Added project to localStorage for product:', productId);
    } else {
      console.log('[LoadProject] Project already exists in localStorage');
    }

    // Clean up URL by removing the pp_project parameter
    urlParams.delete('pp_project');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    if (newUrl !== window.location.pathname + window.location.search) {
      window.history.replaceState(null, '', newUrl);
      console.log('[LoadProject] Cleaned URL by removing pp_project parameter');
    }

  } catch (e) {
    console.error('[LoadProject] Error handling project:', e);
  }

  console.log('[LoadProject] Script completed - PitchPrint should discover project');

})();